export default "__VITE_ASSET__15f5b7ff__"